// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Rana backend API
 * The API service for Rana.
 *
 * The version of the OpenAPI document: v1-alpha
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 * A value object for updating citation information.
 * @export
 * @interface CitationUpdate
 */
export interface CitationUpdate {
  /**
   * Naam van de dataset of dataset serie.
   */
  title?: string | null;
}

/**
 * Check if a given object implements the CitationUpdate interface.
 */
export function instanceOfCitationUpdate(value: object): value is CitationUpdate {
  return true;
}

export function CitationUpdateFromJSON(json: any): CitationUpdate {
  return CitationUpdateFromJSONTyped(json, false);
}

export function CitationUpdateFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): CitationUpdate {
  if (json == null) {
    return json;
  }
  return {
    title: json["title"] === undefined ? undefined : json["title"] === null ? null : json["title"],
  };
}

export function CitationUpdateToJSON(json: any): CitationUpdate {
  return CitationUpdateToJSONTyped(json, false);
}

export function CitationUpdateToJSONTyped(
  value?: CitationUpdate | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    title: value["title"],
  };
}
